export default function Services() {
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4" style={{ fontFamily: '"Noto Serif JP", serif' }}>
              事業内容
            </h2>
            <div className="w-16 h-1 bg-green-600 mx-auto"></div>
          </div>

          <div className="space-y-6">
            <div className="bg-white border border-gray-300 p-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-green-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-briefcase-line text-2xl text-green-700"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    営業代行業務
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-4" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    お客様の営業活動を代行し、ビジネスの成長をサポートいたします。新規顧客開拓から既存顧客のフォローアップまで、幅広い営業活動に対応しております。
                  </p>
                  <ul className="space-y-2 text-gray-700" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    <li className="flex items-start gap-2">
                      <span className="text-green-700 mt-1">■</span>
                      <span>新規顧客開拓</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-700 mt-1">■</span>
                      <span>既存顧客フォローアップ</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-700 mt-1">■</span>
                      <span>商談・プレゼンテーション</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-700 mt-1">■</span>
                      <span>営業戦略立案・実行支援</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-white border border-gray-300 p-8">
              <h3 className="text-xl font-bold text-gray-800 mb-4" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                サービスの特徴
              </h3>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="border-l-4 border-green-600 pl-4">
                  <h4 className="font-bold text-gray-800 mb-2" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    柔軟な対応
                  </h4>
                  <p className="text-sm text-gray-700" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    お客様のニーズに合わせた柔軟なサービス提供を心がけております
                  </p>
                </div>
                <div className="border-l-4 border-green-600 pl-4">
                  <h4 className="font-bold text-gray-800 mb-2" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    丁寧なコミュニケーション
                  </h4>
                  <p className="text-sm text-gray-700" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    定期的な報告と密なコミュニケーションで安心をお届けします
                  </p>
                </div>
                <div className="border-l-4 border-green-600 pl-4">
                  <h4 className="font-bold text-gray-800 mb-2" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    成果へのこだわり
                  </h4>
                  <p className="text-sm text-gray-700" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    結果を重視し、お客様の目標達成に向けて全力でサポートします
                  </p>
                </div>
                <div className="border-l-4 border-green-600 pl-4">
                  <h4 className="font-bold text-gray-800 mb-2" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    地域密着
                  </h4>
                  <p className="text-sm text-gray-700" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    神奈川県横須賀市を中心に、地域に根ざしたサービスを提供します
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}